@if (isDragged()) {
  <tui-icon class="shrink-0 text-text-primary" icon="@tui.smile" />
  @if (draggedLabel()) {
    <span class="line-clamp-2 text-text-primary" data-testid="dropzone-dragged-label">{{ draggedLabel() }}</span>
  }
} @else {
  <tui-icon class="shrink-0 text-text-secondary" icon="@tui.plus" />
  @if (label()) {
    <span class="line-clamp-2 text-text-secondary" data-testid="dropzone-label">{{ label() }}</span>
  }
}
